import React from 'react';
import {inject, observer} from 'mobx-react';
import {DropDown, InputField} from '../../../InputForms';
import styles from './style.css';

const SubscriptionPlan = inject('localizationStore')(observer(
    ({localizationStore, subscription, onChange}) => {
        const locale = localizationStore.locale
        const onInputChange = (event) => {
            let state = subscription
            if (event.target.name === 'salary') {
                state.agentSubscriptionPlanPricings[0].salary = event.target.value
            } else {
                state[event.target.name] = event.target.value
            }
            onChange(state)
        }
        const currencyValues = [{value: 'EUR', label: locale.euro}]
        return (
            <div className={styles.sPlan}>
                <div className={styles.period}>
                    {subscription.agentSubscriptionPlanOwnerType} - {subscription.subscriptionInterval}
                </div>
                <InputField value={subscription.capacity}
                            required
                            type='number'
                            name='capacity'
                            label={locale.capacity}
                            onChange={onInputChange}
                />
                <DropDown style={styles.currencySelection}
                          required
                          name='currency'
                          options={currencyValues}
                          value={subscription.currency}
                          onChange={onInputChange}
                          label={locale.currency}
                />
                <InputField value={subscription.agentSubscriptionPlanPricings[0].salary}
                            required
                            type='number'
                            name='salary'
                            label={locale.salary}
                            onChange={onInputChange}
                />
            </div>
        );
}))

export default SubscriptionPlan;



// WEBPACK FOOTER //
// ./src/components/AddAgentModal/components/SubscriptionPlan/index.js